module.exports = __webpack_public_path__ + "images/a367c1ec0ab6cfec4cf7b2637cfebc74-IMG_8211.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/kitchen/IMG_8211.jpg
// module id = ./src/assets/images/slides/kitchen/IMG_8211.jpg
// module chunks = 0